// extracted by mini-css-extract-plugin
export default {"controls":"Controls_controls__MdB0I"};